import useVatInflowsTable from "./useVatInflowsTable";
import secondaryComponents from "..";
import Orderflows from "../StoreCheckout/Orderflows";
import ReturnDetails from "../ReturnDetails";

const VatOutflowsTable = ({
  metaDetails,
  vatOutflowData,
  selectedTab,
  gotoPage,
}) => {
  const {
    instance,
    selectedOrder,
    selectedReturnOrder,
    setSelectedOrder,
    setSelectedReturnOrder,
  } = useVatInflowsTable({
    vatOutflowData,
    selectedTab,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <h4 className="py-5 text-center">No Data Available</h4>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {vatOutflowData?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.Modal
        isActive={selectedOrder !== null}
        closeModal={() => setSelectedOrder(null)}
        width={1300}
        padding={0}
        style={{ maxHeight: "100%", height: "100vh", borderRadius: "0" }}
      >
        <Orderflows
          closeModal={() => setSelectedOrder(null)}
          orderId={selectedOrder}
          defaultLanding={"tnxReceipt"}
          viaSaleRecord={false}
        />
      </secondaryComponents.Modal>
      <secondaryComponents.Modal
        isActive={selectedReturnOrder !== null}
        closeModal={() => setSelectedReturnOrder(null)}
        width={1300}
        padding="10px"
        style={{ maxHeight: "100%", height: "100vh", borderRadius: "0" }}
      >
        <ReturnDetails
          closeModal={() => setSelectedReturnOrder(null)}
          orderId={selectedReturnOrder}
          defaultLanding={"tnxReceipt"}
          viaSaleRecord={true}
        />
      </secondaryComponents.Modal>
    </>
  );
};

export default VatOutflowsTable;
